import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import * as actions from "../actions";
import LtcForm from "./LtcForm";
import TreatmentForm from "./TreatmentForm";
import BalloonBlue from "../assets/images/graphic-balloon-blue.png";
import HouseBlue from "../assets/images/graphic-house-blue.png";
import ReactHtmlParser from "react-html-parser";

class PickForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formSelection: null,
            EnglishSampleForm: null,
            EnglishSampleFormLTC: null,
        };
    }

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const formSelected = urlParams.get("formSelected");
        this.selectFormType(formSelected);

        // English Sample Form
        fetch(
            "https://cdn.contentful.com/spaces/hac178phwz3f/environments/ac_3.3.1_q4-updates/entries/sMXGcYsV8V3vlX8r6O3Gy?access_token=3WVWEWhJIJmvEO9NiQ4CGS8Tbk8Zb2GAeDDdYwUFqK4"
        )
            .then((response) => response.json())
            .then((data) => {
                this.setState({
                    EnglishSampleForm: ReactHtmlParser(data.fields.content),
                });
            })
            .catch((error) => console.error(error));

        // English Sample Form LTC
        fetch(
            "https://cdn.contentful.com/spaces/hac178phwz3f/environments/ac_3.3.1_q4-updates/entries/vvAL0cIiN9W2MWiAySwG2?access_token=3WVWEWhJIJmvEO9NiQ4CGS8Tbk8Zb2GAeDDdYwUFqK4"
        )
            .then((response) => response.json())
            .then((data) => {
                this.setState({
                    EnglishSampleFormLTC: ReactHtmlParser(data.fields.content),
                });
            })
            .catch((error) => console.error(error));
    }

    selectFormType = (formType) => {
        this.setState({
            ...this.state,
            formSelection: formType,
        });
    };

    scrollToForm = () => {
        this.toBottom.current.scrollIntoView({ behavior: "smooth" });
    };

    resetForm = () => {
        // Set step back to 1
        this.props.updateStep(1);
        // Remove all the answers in redux
        this.props.resetQuestionOptions();
    };

    // This allows us to scroll to top on next/previous
    toTop = createRef();
    toBottom = createRef();
    formRef = createRef();

    render() {
        const { formSelection } = this.state;
        let form;

        if (formSelection === "treatment") {
            form = (
                <TreatmentForm
                    {...this.props}
                    formRef={this.formRef}
                    toTop={this.toTop}
                />
            );
        } else if (formSelection === "ltc") {
            form = (
                <LtcForm
                    {...this.props}
                    formRef={this.formRef}
                    toTop={this.toTop}
                />
            );
        }

        return (
            <div>
                <div id="pick-form-component" className="container">
                    <div ref={this.toTop} className="row">
                        <div
                            id="start-form-message"
                            className="col-md-9"
                            style={{
                                opacity:
                                    formSelection === "treatment" ||
                                    formSelection === null
                                        ? "1.0"
                                        : "0.4",
                            }}
                        >
                            <p>
                                You can also{" "}
                                <a
                                    href="/nuplazid/pdf/treatment-service-form-nuplazid.pdf"
                                    target="_blank"
                                >
                                    <u>
                                        download a PDF version of the Treatment
                                        & Service Request Form
                                    </u>
                                </a>
                                &nbsp;
                                <br class="desktop" />
                                to fill out and email to{" "}
                                <a
                                    class="nobr"
                                    target="_blank"
                                    href="mailto:nuplazid@acadiaconnect.com"
                                >
                                    <u>nuplazid@acadiaconnect.com</u>
                                </a>
                                .
                            </p>

                            <div className="row spacer-small">&nbsp;</div>
                            <button
                                className={
                                    "button blue" +
                                    (formSelection === "treatment"
                                        ? " active"
                                        : "") +
                                    " gtm-start-treatment-form"
                                }
                                type="button"
                                onClick={(e) => {
                                    console.log(
                                        "this.formRef.form ",
                                        this.formRef
                                    );
                                    if (
                                        formSelection === "ltc" &&
                                        this.formRef.current
                                    ) {
                                        this.resetForm();
                                    }
                                    this.selectFormType("treatment");
                                    this.scrollToForm();
                                }}
                            >
                                START THE FORM
                            </button>

                            <div className="row spacer-small">&nbsp;</div>

                            <div className="row spacer-xsmall">&nbsp;</div>
                            <h4 class="blue-font-35-gelo mt-2 mb-2">
                                Sample Treatment & Service Request Form
                            </h4>

                            <p>
                                Need assistance with completing the Treatment &
                                Service Request Form? Download the annotated
                                sample form below. It includes prefilled fields
                                and instructions to guide you through the
                                process.
                            </p>

                            <div class="row">
                                <div class="col-12 col-lg-8">
                                    <div class="dp-content dropdown treatment-and-service-request-form">
                                        Select
                                        <i
                                            class="fa fa-chevron-down"
                                            aria-hidden="true"
                                        ></i>
                                        <i
                                            class="fa fa-chevron-up"
                                            aria-hidden="true"
                                        ></i>
                                        <div>
                                            <p>
                                                {this.state.EnglishSampleForm &&
                                                    this.state
                                                        .EnglishSampleForm}
                                            </p>
                                            <p>
                                                {this.state
                                                    .EnglishSampleFormLTC &&
                                                    this.state
                                                        .EnglishSampleFormLTC}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/*<div className="row spacer-medium mobile">&nbsp;</div>
                                    <div className="row spacer-small mobile">&nbsp;</div>*/}
                        </div>
                        {/* <div className="col-md-4" style={{opacity: (((formSelection === "ltc") || (formSelection === null)) ? "1.0" : "0.4")}}>
                                <h3 className="blue-font-44-gelo mt-2 mb-2">long-term care.</h3>
                                <p>To request long-term care access support for your patient, complete the service request form.</p>
                                    <button
                                        className={"button blue" + (formSelection === "ltc" ? " active" : "") + " gtm-start-svs-request-form"}
                                        type="button"
                                        onClick={(e) => {
                                            console.log("this.formRef.form 2 ", this.formRef);
                                            if(formSelection === "treatment" && this.formRef.current) {
                                                this.resetForm();
                                            }
                                            this.selectFormType("ltc");
                                            this.scrollToForm();
                                        }}
                                    >
                                        GET STARTED 
                                    </button>
                            </div> */}
                        <div className="col-md-3"></div>
                        <div className="toBottom" ref={this.toBottom}></div>
                    </div>
                    <div className="row spacer-large desktop-sm">&nbsp;</div>
                    <div className="row spacer-medium mobile-sm">&nbsp;</div>
                    <div className="row spacer-small mobile-sm">&nbsp;</div>
                    <div className="row">
                        <div
                            id="hcp-enrollment-footnote"
                            className="col-sm-8"
                            style={{ fontSize: "13px" }}
                        >
                            <p style={{ lineHeight: "20px" }}>
                                <span className="hang-left-4">*</span>Free
                                14-day supply of NUPLAZID is available to
                                eligible patients enrolled in Acadia Connect and
                                who are prescribed NUPLAZID by their healthcare
                                provider. Acadia Connect{" "}
                                <a
                                    href="/nuplazid/pdf/program-details-and-patient-eligibility.pdf"
                                    className="underline-link"
                                    target="_blank"
                                >
                                    patient eligibility and terms and conditions
                                </a>{" "}
                                apply.
                            </p>
                        </div>
                    </div>
                </div>
                {form}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { currentStep } = state;
    return { currentStep: currentStep };
};

export default connect(mapStateToProps, actions)(PickForm);
